import { apiMutate } from 'service/utils/mutation';

import { useDeliveryZoneMsToken } from 'hooks';
import { UpdateBulkDeliveryZonesInput, UpdateBulkDeliveryZonesPayload } from '../../types/generated';
import { updateBulkDeliveryZoneMutation } from '../../mutations';

type useUpdateBulkDeliveryZoneType = () => ({
  input,
}: {
  input?: UpdateBulkDeliveryZonesInput;
}) => Promise<void | Partial<UpdateBulkDeliveryZonesPayload> | { hasError: boolean }>;

const useUpdateBulkDeliveryZone: useUpdateBulkDeliveryZoneType = () => {
  const deliveryZoneMsToken = useDeliveryZoneMsToken();
  return input =>
    apiMutate({
      mutation: updateBulkDeliveryZoneMutation,
      variables: { input },
      requestHeaders: { token: deliveryZoneMsToken },
      handler: (res: any) => res,
    });
};

export default useUpdateBulkDeliveryZone;
